var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 6.75001H13.75L9.6375 2.63751C9.52034 2.52131 9.42735 2.38306 9.36388 2.23074C9.30042 2.07841 9.26775 1.91503 9.26775 1.75001C9.26775 1.585 9.30042 1.42162 9.36388 1.26929C9.42735 1.11697 9.52034 0.978718 9.6375 0.862514C9.8717 0.6297 10.1885 0.499023 10.5187 0.499023C10.849 0.499023 11.1658 0.6297 11.4 0.862514L16.7625 6.23751C17.232 6.7042 17.4972 7.33804 17.5 8.00001C17.4939 8.65765 17.2289 9.28639 16.7625 9.75001L11.4 15.125C11.2835 15.2407 11.1453 15.3324 10.9933 15.3947C10.8413 15.457 10.6786 15.4888 10.5143 15.4882C10.3501 15.4876 10.1876 15.4547 10.036 15.3913C9.88453 15.3279 9.74698 15.2353 9.63125 15.1188C9.51552 15.0022 9.42388 14.864 9.36157 14.7121C9.29925 14.5601 9.26747 14.3973 9.26805 14.2331C9.26863 14.0688 9.30156 13.9063 9.36495 13.7548C9.42834 13.6033 9.52095 13.4657 9.6375 13.35L13.75 9.25001H1.25C0.918478 9.25001 0.600534 9.11832 0.366114 8.8839C0.131693 8.64948 -1.90735e-06 8.33153 -1.90735e-06 8.00001C-1.90735e-06 7.66849 0.131693 7.35055 0.366114 7.11613C0.600534 6.88171 0.918478 6.75001 1.25 6.75001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/nextIcon.a9c3c0c392cb020ec9010565862276dd.svg";
export { ForwardRef as ReactComponent };